// removed by extract-text-webpack-plugin
module.exports = {"heroContainer":"_1z2UBUEA6WrnvZatpdbF_j","mainContainer":"dLEsmLU-QlY4bUlAQ7VnR","title":"_2WBhv6KYxXKklhVv58bHMJ","text":"_2yfQp-DvQFETc0a4p7akti","dataContainer":"_3xYOIXm8V7xvU8dRcyxx58","buttonSubmit":"_2jL_p5nh-9MkzZ2_ypJxkl","inputName":"_3QR0Z7LEx_Vim2T35Az96P","errorLabel":"_3UFLw4_U-Wy_N5lftwKyTi"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/Home.css
// module id = 241
// module chunks = 0